const ms = require('../msysMessage')
const logger_worker = {}
module.exports = logger_worker

let filter_function
let max_length = 0
let messages_before_config = []

function cloneDeep(obj) {
  try{
    const out = structuredClone(obj)
    return out
  }catch(e) {
    if(obj instanceof Node) {
      return null
    }else if(Array.isArray(obj)) {
      return obj.map(cloneDeep)
    }else if(obj && typeof obj==='object') {
      const out = {}
      for(const key in obj) {
        out[key] = cloneDeep(obj[key])
      }
      return out
    }else {
      return null
    }
  }
} // cloneDeep

console.debug_orig = console.debug2 = console.debug
console.log_orig = console.log2 = console.log
console.info_orig = console.info2 = console.info
console.warn_orig = console.warn2 = console.warn
console.error_orig = console.error2 = console.error
console.logger_worker = logger_worker

console.debug = function(...args) {
  logger_worker.debug('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.log = function(...args) {
  logger_worker.log('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.info = function(...args) {
  logger_worker.info('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.warn = function(...args) {
  logger_worker.warn('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}
console.error = function(...args) {
  logger_worker.error('console', args.map(a=>typeof (a)==='string'?a:JSON.stringifySafe(a)).join(' '))
}

logger_worker.debug = function(sender, text, dt, level) {
  logger_worker.postMessage({ dt: dt||unow(), sender, target: 'msysLogger', action: 'mmDebug', params: { level, text } })
}
logger_worker.log = function(sender, text, dt) {
  logger_worker.postMessage({ dt: dt||unow(), sender, target: 'msysLogger', action: 'mmDebug', params: { text } })
}
logger_worker.info = function(sender, text, dt) {
  logger_worker.postMessage({ dt: dt||unow(), sender, target: 'msysLogger', action: 'mmInfo', params: { text } })
}
logger_worker.warn = function(sender, text, dt) {
  logger_worker.postMessage({ dt: dt||unow(), sender, target: 'msysLogger', action: 'mmWarning', params: { text } })
}
logger_worker.error = function(sender, text, dt) {
  logger_worker.postMessage({ dt: dt||unow(), sender, target: 'msysLogger', action: 'mmError', params: { text } })
}
logger_worker.message = function(sender, target, action, params, dt) {
  if(action==='mmH264') {
    params = { ...params }
    if(typeof params.payload !== 'string') params.payload = new Uint8Array(0)
  }else {
    params = cloneDeep(params)
  }
  logger_worker.postMessage({ dt: dt||unow(), sender, target, action, params })
}

logger_worker.postMessage = ({ config, sender, target, action, params }) => {
  try{
    if(config) return configure(config)
    if(filter_function===null) return // we are configured to do nothing

    if(typeof action!=='string' || action==='') return
    const sender_txt = typeof sender==='string' ? sender : ms.address2string(sender)
    if(!sender_txt) return
    const target_txt = ms.address2string(target)
    if(!target_txt) return
    params = params && typeof params==='object' ? params : {}
    const event_dt = params.event_dt>0 ? params.event_dt : unow()
    if(filter_function) {
      if(!filter_function(sender, target, action, params)) return
      delete params.event_dt
      if(typeof window === 'object') {
        logMessageInBrowser(event_dt, sender_txt, target_txt, action, params)
      }else {
        logMessageInTerminal(event_dt, sender_txt, target_txt, action, params)
      }
    }else{
      messages_before_config.push({ sender, target, action, params }) // store messages coming before configuration
    }
  }catch(e) {
    console.error_orig(e)
  }
} // onmessage

////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Process incoming configuration
 */
function configure(new_config) {
  const first_configuration = typeof (filter_function)==='undefined'
  const filter = new_config && typeof new_config ==='object' ? new_config.filter : null
  filter_function = (filter ? ms.createFilterFunction(filter) : null) || null
  max_length = new_config && typeof new_config ==='object' ? new_config.max_length : 0

  if(first_configuration && filter_function) {
    // after configuration display all logs received so far
    messages_before_config = messages_before_config.sort((a, b)=>a.params.event_dt-b.params.event_dt)
    while(messages_before_config.length>0) {
      const msg = messages_before_config.shift()
      logger_worker.postMessage(msg)
    }
  }
} // configure

function logMessageInTerminal(event_dt, sender, target, action, params) {
  const time = timestampString(event_dt)
  let color
  let content
  if(action==='mmDebug') {
    color = '\x1b[33;1m' // yellow
    content = `{DEBUG} ${time}${sender}: ${String(params.text)}`
  }else if(action==='mmInfo') {
    color = '\x1b[30;102m' // BLACK ON GREEN
    content = `{INFO}  ${time}${sender}: ${String(params.text)}`
  }else if(action==='mmWarning') {
    color = '\x1b[30;103m' // BLACK ON YELLOW
    content = `{WARN}  ${time}${sender}: ${String(params.text)}`
  }else if(action==='mmError') {
    color = '\x1b[41;97;1m' // WHITE ON RED
    content = `{ERROR} ${time}${sender}: ${String(params.text)}`
  }else{
    color = '\x1b[37;1m' // bright white
    content = `{MSG}   ${time}${ms.msg2string({ sender, target, action, params })}`
  }

  if(max_length > 0) {
    if(content.length > max_length) content = content.substring(0, max_length)
  }else if(max_length < 0) {
    const cols = typeof process === 'object' ? process.stdout?.columns : 0
    const max = (cols > 0 ? cols : 80) - 1
    if(content.length > max) content = content.substring(0, max)
  }
  console.log_orig(color + content + '\x1b[0m')
} // logMessageInNodeConsole

function logMessageInBrowser(event_dt, sender, target, action, params) {
  const time = timestampString(event_dt)

  const stack = String(new Error().stack??'')
  let caller = stack.split('\n')[5].trim().replace(/^at /, '')

  if(action==='mmDebug') {
    const text = String(params.text).substr(0, max_length>0 ? max_length : params.text.length)
    return console.debug_orig(`%c{DEBUG} ${time}${sender}: ${text} ${caller}`, 'color: gray')
  }else if(action==='mmInfo') {
    const text = String(params.text).substr(0, max_length>0 ? max_length : params.text.length)
    return console.info_orig(`%c{INFO}  ${time}${sender}: ${text} ${caller}`, 'background: #CF8; color: #000; display: block; line-height: 1.5em; padding: 0px 10px 0px 0px; margin: -3px 0px;')
  }else if(action==='mmWarning') {
    const text = String(params.text).substr(0, max_length>0 ? max_length : params.text.length)
    return console.warn_orig(`{WARN}  ${time}${sender}: ${text} ${caller}`)
  }else if(action==='mmError') {
    const text = String(params.text).substr(0, max_length>0 ? max_length : params.text.length)
    caller = stack.split('\n').slice(5).join('\n')
    return console.error_orig(`{ERROR} ${time}${sender}: ${text}\n${caller}`)
  }

  let params_text = ms.params2string(params)
  params_text = params_text.substr(0, max_length>0 ? max_length : params_text.length)
  const args = [
    '%c{MSG}   ' + time + sender + '%c>%c' + target + '%c' + '.' + '%c' + action + '%c' + '?' + '%c' + params_text,
    'font-weight: bold',
    'color: #888; font-weight: normal; padding: 0px 4px',
    'color: currentcolor; font-weight: bold',
    'color: #888; font-weight: normal; padding: 0px 4px',
    'color: '+(/^mmAction|^mmObjects/.test(action)?'#F0F':'#08F')+'; font-weight: bold',
    'color: #888; font-weight: normal; padding: 0px 4px',
    'color: currentcolor; font-weight: normal',
  ]

  // display data as table
  let displayed = false
  const table_params = ['list']
  if(params && typeof (params)==='object') {
    for(const p of table_params) {
      const data = params[p]
      if(Array.isArray(data) && data.length>0) {
        if(!displayed) console.groupCollapsed.apply(console, args)
        displayed = true
        // for(let i=0; i<data.length; i++) config.maskParamsFunction(config, action, data[i])
        const title = action==='mmObjects' && p==='list' && params.type ? params.type : action+'.'+p
        const version_limited = p==='list' ? ` ${params.limited?'LIMITED':'FULL'}${isNaN(params.version)?'':' version '+params.version}` : ''
        console.log_orig('%c             '+title+'%c: '+data.length+' items'+version_limited, (action==='mmObjects'?'color: #F0F':'color: #08F')+';font-weight: bold;', 'font-weight:normal;')
        console.table(data)
      }
    }
  }
  if(displayed) console.groupEnd()
  else console.log_orig.apply(console, args)
} // logMessageInBrowserConsole

function timestampString(dt) {
  try{
    const d = new Date(Math.floor(dt/1000))
    if(isNaN(d)) return '[] '
    return '['+d.toLocaleString('lt-lt')+'.'+String(dt % 1_000_000).padStart(6, '0')+'] '
  }catch(e) {
    return '[] '
  }
} // timestampString

logger_worker.info('system', 'STARTING APPLICATION '+MOSY_APP_WITH_VERSION, MOSY_PROCESS_START_US)
logger_worker.debug('system', 'STARTING SCRIPT', MOSY_SCRIPT_START_US)
